module.exports = __webpack_public_path__ + "img/post_img_10-700x441.61965f98.jpg";